import { Component, Input, OnInit } from '@angular/core';
import { LoggerService } from '../providers/logger.service';

@Component({
  selector: 'app-savetogdrive',
  template: `
   <span class='g-savetodrive'></span>
  `,
  styles: [
  ]
})
export class SavetogdriveComponent implements OnInit {
  @Input() abxSrc: any;
  @Input() abxFilename: any;
  @Input() abxSitename: any;
  
  element: any; // = $element[0];

  constructor(private logger: LoggerService) { }

  ngOnInit(): void {
    try {
      var filename = this.abxFilename;
      if (filename.length < 4 || filename.substring(filename.length - 4) !== "swrd") filename = filename + ".swrd";
      // TODO Preveri kako je prej deloval ta gapi
      //gapi.savetodrive.render(this.element, { "src": this.abxSrc, "filename": filename, "sitename": this.abxSitename });
    } catch (e) {
      this.logger.logInternalError("GDRIVE BUTTON ONINIT", e.message);
    }
  }

}
